export const projectsData = [
  {
    slug: "tai-tao-trai-nghiem-so",
    title: "Tái Tạo Trải Nghiệm Số",
    categories: "Phát triển",
    client: "Webflow",
    startDate: "23 Tháng 1, 2024",
    handoverDate: "05 Tháng 3, 2024",
    shortDescription:
      "Tại Design24, chúng tôi tự hào mang đến những giải pháp độc đáo và tạo dấu ấn khác biệt cho từng dự án. Mục tiêu của chúng tôi là giúp thương hiệu kết nối hiệu quả với đúng khách hàng mục tiêu.",
    mainImage: "/assets/img/project/06.jpg",

    overviewTitle: "Tổng Quan Dự Án",
    overviewText: [
      "Design24 cam kết kiến tạo giải pháp thiết kế và truyền thông phù hợp với từng khách hàng. Danh mục dự án đa dạng của chúng tôi trải dài nhiều lĩnh vực, chứng minh năng lực kết hợp giữa sáng tạo và chiến lược để mang đến kết quả thiết thực và đo lường được. Từ xây dựng thương hiệu, thiết kế website, marketing số đến phát triển nhận diện hình ảnh, mọi dự án đều được triển khai với sự tỉ mỉ, sáng tạo và đổi mới.",
      "Chúng tôi chuyên tạo dựng bản sắc thương hiệu mạnh mẽ, truyền tải đúng tinh thần doanh nghiệp và chạm đến cảm xúc khách hàng mục tiêu. Ví dụ, dự án hợp tác với Adenko Corporation đã khẳng định năng lực làm mới thương hiệu thông qua nghiên cứu chuyên sâu và thiết kế chiến lược toàn diện.",
    ],

    hoverImg: "/assets/img/project/01.jpg",
    additionalImages: [
      { src: "/assets/img/project/details-2.jpg", col: 7 },
      { src: "/assets/img/project/details-3.jpg", col: 5 },
    ],

    challengesTitle: "Thách Thức & Giới Hạn",
    challengesText:
      "Đội ngũ Design24 nổi bật với khả năng xây dựng và triển khai các chiến dịch marketing số mạnh mẽ, thúc đẩy tương tác và chuyển đổi. Với khách hàng như ABC Fashion, chúng tôi đã thiết kế bộ ấn phẩm quảng bá trực quan cho mạng xã hội và quảng cáo trực tuyến, góp phần tăng trưởng doanh số và củng cố hiện diện số.",
    challengesList: [
      [
        "Thị trường bất động sản dân cư có tính cạnh tranh cao.",
        "Khách hàng yêu cầu trải nghiệm liền mạch trên đa thiết bị.",
        "Yếu tố công nghệ đóng vai trò then chốt trong giải pháp.",
      ],
      [
        "Doanh nghiệp cần duy trì sự nhất quán trong thương hiệu.",
        "Các yêu cầu kinh doanh thường xuyên thay đổi và mở rộng.",
      ],
    ],

    solutionTitle: "Giải Pháp Triển Khai",
    solutionText:
      "Trong mỗi dự án thiết kế website, chúng tôi luôn ưu tiên trải nghiệm người dùng và sự đồng bộ thương hiệu. Điển hình, với GreenTech Innovations, Design24 đã xây dựng một website hiện đại, trực quan, nhấn mạnh nỗ lực phát triển bền vững của họ. Kết quả là mức độ tương tác của người dùng được cải thiện đáng kể, đồng thời gia tăng số lượng khách hàng tiềm năng liên hệ. Bên cạnh đó, chúng tôi cũng phát triển các chiến dịch marketing số mạnh mẽ, mang lại hiệu quả chuyển đổi rõ rệt.",

    finalResultTitle: "Kết Quả Cuối Cùng",
    finalResultText:
      "Website mới của GreenTech Innovations đã tạo ấn tượng mạnh mẽ với giao diện hiện đại, điều hướng mượt mà và nội dung nhất quán với thương hiệu. Dự án không chỉ cải thiện trải nghiệm người dùng mà còn giúp gia tăng tương tác, khẳng định hình ảnh thương hiệu chuyên nghiệp và bền vững trong mắt khách hàng.",

    prevPost: null,
    nextPost: {
      title: "Thiết Kế Định Hình Tăng Trưởng",
      slug: "thiet-ke-dinh-hinh-tang-truong",
    },
  },
  {
    slug: "thiet-ke-dinh-hinh-tang-truong",
    title: "Thiết Kế Định Hình Tăng Trưởng",
    categories: "Website, UI/UX",
    client: "Figma",
    startDate: "10 Tháng 2, 2024",
    handoverDate: "15 Tháng 4, 2024",
    shortDescription:
      "Dự án tập trung xây dựng giải pháp số hiện đại, thúc đẩy tăng trưởng và tạo trải nghiệm UI/UX ấn tượng để thu hút khách hàng mục tiêu.",
    mainImage: "/assets/img/project/06.jpg",

    overviewTitle: "Tổng Quan Dự Án",
    overviewText: [
      "Đội ngũ Design24 đã thực hiện tái thiết kế toàn diện cho hiện diện số của khách hàng, nhấn mạnh vào khả năng kể chuyện bằng hình ảnh và tính dễ sử dụng.",
      "Mục tiêu chính là tạo ra một trải nghiệm lôi cuốn, tối ưu chuyển đổi và củng cố bản sắc thương hiệu trong môi trường số.",
    ],

    hoverImg: "/assets/img/project/01.jpg",
    additionalImages: [
      { src: "/assets/img/project/details-2.jpg", col: 7 },
      { src: "/assets/img/project/details-3.jpg", col: 5 },
    ],

    challengesTitle: "Thách Thức & Giới Hạn",
    challengesText:
      "Bài toán đặt ra là vừa đảm bảo trải nghiệm người dùng liền mạch, vừa giữ vững phong cách nhận diện thương hiệu đặc trưng.",
    challengesList: [
      [
        "Đảm bảo thiết kế tuân thủ bộ nhận diện thương hiệu.",
        "Tối ưu khả năng hiển thị trên mọi thiết bị.",
      ],
      [
        "Tích hợp các thành phần tương tác mới.",
        "Duy trì sự nhất quán xuyên suốt các trang.",
      ],
    ],

    solutionTitle: "Giải Pháp Triển Khai",
    solutionText:
      "Chúng tôi xây dựng hệ thống thiết kế linh hoạt với các thành phần mô-đun, giúp duy trì sự đồng bộ và dễ dàng mở rộng trong tương lai.",

    finalResultTitle: "Kết Quả Cuối Cùng",
    finalResultText:
      "Website mới sở hữu giao diện hiện đại, trực quan, gia tăng chỉ số tương tác và mang lại sự hài lòng cao hơn cho người dùng.",

    prevPost: {
      title: "Tái Tạo Trải Nghiệm Số",
      slug: "tai-tao-trai-nghiem-so",
    },
    nextPost: {
      title: "Tái Tạo Nhận Diện Thương Hiệu",
      slug: "tai-tao-nhan-dien-thuong-hieu",
    },
  },
  {
    slug: "tai-tao-nhan-dien-thuong-hieu",
    title: "Tái Tạo Nhận Diện Thương Hiệu",
    categories: "Website, UI/UX",
    client: "Adobe",
    startDate: "01 Tháng 3, 2024",
    handoverDate: "20 Tháng 5, 2024",
    shortDescription:
      "Dự án tập trung nâng tầm nhận diện thương hiệu, giúp truyền tải rõ nét tầm nhìn và giá trị cốt lõi của doanh nghiệp trên mọi nền tảng số.",
    mainImage: "/assets/img/project/06.jpg",

    overviewTitle: "Tổng Quan",
    overviewText: [
      "Chúng tôi tiến hành phân tích toàn bộ hệ thống nhận diện hiện có và xây dựng bộ nhận diện hình ảnh mới, hiện đại và đồng nhất hơn.",
      "Các yếu tố thiết kế được triển khai đồng bộ trên website, mạng xã hội và tài liệu truyền thông, đảm bảo sự nhất quán và tính chuyên nghiệp.",
    ],

    hoverImg: "/assets/img/project/01.jpg",
    additionalImages: [
      { src: "/assets/img/project/details-2.jpg", col: 7 },
      { src: "/assets/img/project/details-3.jpg", col: 5 },
    ],

    challengesTitle: "Thách Thức & Giới Hạn",
    challengesText:
      "Cập nhật bộ nhận diện cũ nhưng vẫn phải duy trì sự quen thuộc và đảm bảo tính đồng bộ trên mọi nền tảng.",
    challengesList: [
      [
        "Giữ vững khả năng nhận diện thương hiệu.",
        "Tích hợp logo và màu sắc mới.",
      ],
      [
        "Đảm bảo tính dễ đọc và khả năng sử dụng trên nhiều kênh truyền thông.",
        "Đáp ứng mong muốn và định hướng từ các bên liên quan.",
      ],
    ],

    solutionTitle: "Giải Pháp Thực Hiện",
    solutionText:
      "Xây dựng bộ brand guideline toàn diện, đồng thời cập nhật toàn bộ tài sản số để phản ánh phong cách thương hiệu mới.",

    finalResultTitle: "Kết Quả Cuối Cùng",
    finalResultText:
      "Một hệ thống nhận diện hiện đại, giàu tính thẩm mỹ, thể hiện rõ bản sắc thương hiệu và tạo sự kết nối mạnh mẽ với khách hàng mục tiêu.",

    prevPost: {
      title: "Thiết Kế Định Hình Tăng Trưởng",
      slug: "thiet-ke-dinh-hinh-tang-truong",
    },
    nextPost: {
      title: "Tối Ưu Giá Trị Qua Thiết Kế",
      slug: "toi-uu-trai-nghiem-qua-thiet-ke",
    },
  },
  {
    slug: "toi-uu-trai-nghiem-qua-thiet-ke",
    title: "Tối Ưu Trải Nghiệm Qua Thiết Kế",
    categories: "Website, UI/UX",
    client: "Sketch",
    startDate: "15 Tháng 3, 2024",
    handoverDate: "25 Tháng 5, 2024",
    shortDescription:
      "Dự án tập trung cải thiện trải nghiệm người dùng và thiết kế tương tác, nhằm tăng mức độ gắn kết và tỷ lệ chuyển đổi trên toàn nền tảng.",
    mainImage: "/assets/img/project/06.jpg",

    overviewTitle: "Tổng Quan Dự Án",
    overviewText: [
      "Thiết kế lại giao diện cho các luồng người dùng quan trọng, giúp đơn giản hóa điều hướng và giảm tối đa rào cản trải nghiệm.",
      "Ứng dụng các nguyên tắc UX tốt nhất để đảm bảo sự trực quan, dễ sử dụng và mang lại sự hài lòng cho người dùng.",
    ],

    hoverImg: "/assets/img/project/01.jpg",
    additionalImages: [
      { src: "/assets/img/project/details-2.jpg", col: 7 },
      { src: "/assets/img/project/details-3.jpg", col: 5 },
    ],

    challengesTitle: "Thách Thức & Giới Hạn",
    challengesText:
      "Bài toán là cân bằng giữa tính năng nâng cao và một thiết kế tối giản, thân thiện với người dùng.",
    challengesList: [
      [
        "Đơn giản hóa quy trình phức tạp",
        "Duy trì tính nhất quán của UI components",
      ],
      [
        "Đảm bảo tiêu chuẩn tiếp cận (accessibility)",
        "Tối ưu hiệu suất trên mọi thiết bị",
      ],
    ],

    solutionTitle: "Giải Pháp Thực Hiện",
    solutionText:
      "Áp dụng các mẫu điều hướng trực quan và chuẩn hóa hệ thống UI components trên toàn bộ nền tảng để đảm bảo tính đồng nhất và dễ mở rộng.",

    finalResultTitle: "Kết Quả Cuối Cùng",
    finalResultText:
      "Một nền tảng lấy người dùng làm trung tâm, nổi bật với khả năng tương tác mượt mà, tính thẩm mỹ cao và hiệu quả sử dụng vượt trội.",

    prevPost: {
      title: "Tái Tạo Nhận Diện Thương Hiệu",
      slug: "tai-tao-nhan-dien-thuong-hieu",
    },
    nextPost: {
      title: "Hành Trình Hình Ảnh Độc Đáo",
      slug: "hanh-trinh-hinh-anh-doc-dao",
    },
  },
  {
    slug: "hanh-trinh-hinh-anh-doc-dao",
    title: "Hành Trình Hình Ảnh Độc Đáo",
    categories: "Website, UI/UX",
    client: "InVision",
    startDate: "05 Tháng 4, 2024",
    handoverDate: "30 Tháng 6, 2024",
    shortDescription:
      "Tạo nên trải nghiệm thị giác sống động, kết nối cảm xúc với người dùng và củng cố câu chuyện thương hiệu.",
    mainImage: "/assets/img/project/06.jpg",

    overviewTitle: "Tổng Quan Dự Án",
    overviewText: [
      "Thiết kế giao diện nhập vai và trải nghiệm tương tác đồng bộ với câu chuyện thương hiệu.",
      "Tập trung vào hệ thống phân cấp thị giác và chuyển động để dẫn dắt sự chú ý và tăng cường gắn kết người dùng.",
    ],

    hoverImg: "/assets/img/project/01.jpg",
    additionalImages: [
      { src: "/assets/img/project/details-2.jpg", col: 7 },
      { src: "/assets/img/project/details-3.jpg", col: 5 },
    ],

    challengesTitle: "Thách Thức & Giới Hạn",
    challengesText:
      "Đảm bảo trải nghiệm thị giác nhất quán và vận hành mượt mà trên mọi thiết bị.",
    challengesList: [
      [
        "Duy trì nhận diện thương hiệu trên tất cả màn hình",
        "Triển khai animation responsive",
      ],
      [
        "Cân bằng giữa thẩm mỹ và hiệu suất",
        "Dẫn dắt người dùng trực quan qua từng hành trình",
      ],
    ],

    solutionTitle: "Giải Pháp Thực Hiện",
    solutionText:
      "Xây dựng các thành phần thiết kế module hóa và animation linh hoạt để đảm bảo tính đồng nhất và khả năng thích ứng.",

    finalResultTitle: "Kết Quả Cuối Cùng",
    finalResultText:
      "Một hành trình thị giác giàu cảm xúc, giúp nâng cao trải nghiệm và tăng cường sự gắn kết của người dùng.",

    prevPost: {
      title: "Tối Ưu Trải Nghiệm Qua Thiết Kế",
      slug: "toi-uu-trai-nghiem-qua-thiet-ke",
    },
    nextPost: {
      title: "Dự Án Chuyển Đổi Thương Hiệu",
      slug: "du-an-chuyen-doi-thuong-hieu",
    },
  },
  {
    slug: "du-an-chuyen-doi-thuong-hieu",
    title: "Dự Án Chuyển Đổi Thương Hiệu",
    categories: "Website, UI/UX",
    client: "Figma",
    startDate: "15 Tháng 5, 2024",
    handoverDate: "15 Tháng 7, 2024",
    shortDescription:
      "Thực hiện các dự án chuyển đổi thương hiệu quy mô lớn nhằm tái định hình nhận thức và sự hiện diện số của thương hiệu.",
    mainImage: "/assets/img/project/06.jpg",

    overviewTitle: "Tổng Quan Dự Án",
    overviewText: [
      "Triển khai tái thiết kế thương hiệu toàn diện kết hợp với chiến lược mới để nâng cao hình ảnh và giá trị thương hiệu.",
      "Ứng dụng nhận diện mới trên các kênh kỹ thuật số với thông điệp đồng bộ và nhất quán.",
    ],

    hoverImg: "/assets/img/project/01.jpg",
    additionalImages: [
      { src: "/assets/img/project/details-2.jpg", col: 7 },
      { src: "/assets/img/project/details-3.jpg", col: 5 },
    ],

    challengesTitle: "Thách Thức & Giới Hạn",
    challengesText:
      "Đảm bảo tính nhất quán thương hiệu trên nhiều nền tảng trong khi vẫn giới thiệu các yếu tố nhận diện mới.",
    challengesList: [
      [
        "Cập nhật hệ thống thiết kế cũ",
        "Đảm bảo sự đồng thuận của các bên liên quan",
      ],
      ["Điều phối quy trình liên phòng ban", "Quản lý tiến độ gấp rút"],
    ],

    solutionTitle: "Giải Pháp Thực Hiện",
    solutionText:
      "Xây dựng kế hoạch triển khai theo lộ trình rõ ràng cùng với bộ template và guideline chuẩn hóa.",

    finalResultTitle: "Kết Quả Cuối Cùng",
    finalResultText:
      "Một diện mạo thương hiệu mới mẻ, gia tăng sự gắn kết và củng cố nhận diện thị giác thống nhất.",

    prevPost: {
      title: "Hành Trình Hình Ảnh Độc Đáo",
      slug: "hanh-trinh-hinh-anh-doc-dao",
    },
    nextPost: null,
  },
];
